import FormController from '@controllers/portal/components/form_controller';

export default class extends FormController {
  validate(e) {
    let valid = super.validate(e);

    const imageController = this.getControllerByElement(this.formTarget.querySelector('[data-controller*="image-section"]'));
    if (imageController && !imageController.validate()) valid = false;
    if (!valid) {
      this.formTarget.querySelector('.error').scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (e) e.preventDefault();
    }
    return valid;
  }
}
